import request from './request';

export function fetchData() {
  return request({
    method: 'GET',
    url: '/dashboard/data',
    protectedRoute: true,
    newApi: true
  });
}
